import { Notifications } from 'library/constants'

export const copyToClipboard = (e: any, func: any) => {
  e.target.select()
  document.execCommand('copy')
  func(Notifications.copied)
  //todo add check if copy was succesfull
}
